import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import RoleModal from './RoleModal'

function TableStats({ roles, params, setParams }) {
  const [open, setOpen] = React.useState(false)
  const stats = roles.stats
  const statusData = [
    {
      label: 'Critical',
      value: 'critical',
      count: stats.critical,
      color: '#E77152',
      helperText: '>= 60'
    },
    {
      label: 'High',
      value: 'high',
      count: stats.high_risk,
      color: '#fd7e14',
      helperText: '40 - 59'
    },
    {
      label: 'Medium',
      value: 'medium',
      count: stats.mid_risk,
      color: '#E9C46A',
      helperText: '20 - 39'
    },
    {
      label: 'Low',
      value: 'low',
      count: stats.low_risk,
      color: '#606060',
      helperText: '0 - 19'
    }
  ]

  return (
    <Card className="my-4">
      <Card.Body>
        <Row>
          <Col className="text-center" sm={'auto'}>
            <div className="my-2">
              Role Score{' '}
              {false && (
                <span
                  className="ms-2 btn btn-link btn-sm"
                  onClick={() => setOpen(!open)}
                >
                  <FontAwesomeIcon icon={faInfoCircle} /> Learn More
                </span>
              )}
              <RoleModal show={open} setShow={setOpen} />
            </div>
          </Col>
          {statusData.map((status, idx) => (
            <Col key={idx} className="text-center" sm={'auto'}>
              <button
                className={`btn btn-light bg-white ${
                  params.score === status.value ? 'border-primary' : ''
                }`}
                style={{
                  backgroundColor:
                    params.score === status.value ? '#E9ECEF' : '',
                  cursor: 'pointer',
                  textAlign: 'center'
                }}
                onClick={() => {
                  if (params.score !== status.value) {
                    setParams({ ...params, score: status.value })
                  } else {
                    setParams({ ...params, score: '' })
                  }
                }}
              >
                <div>
                  <span
                    style={{
                      height: '10px',
                      width: '10px',
                      borderRadius: '50%',
                      display: 'inline-block',
                      backgroundColor: status.color,
                      marginRight: '6px'
                    }}
                  />
                  <span className="fw-bold me-1">{status.count}</span>
                  <strong>{status.label}</strong>

                  <small className="text-muted ms-2">
                    Score {status.helperText}
                  </small>
                </div>
              </button>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  )
}

export default TableStats
